import { LinkProps } from './Link';
import { Theme, css } from '@emotion/react';

/**
 * When rendering as a button tag make sure that we inherit the text styles
 * from the parent.
 */
export const buttonLink = (theme: Theme) => css`
  &.MuiLink-button {
    font-family: inherit;
    font-size: inherit;
    font-weight: inherit;
  }
`;

export const linkColor =
  (color: LinkProps['color']) =>
  ({ colors }: Theme) => {
    if (color === 'inherit') {
      return css`
        color: inherit;
      `;
    } else {
      return css`
        color: ${colors.fgPrimaryBase};
      `;
    }
  };
